<template>
	<div v-show="isInit" style="padding: 0">
		<div class="summary_container" :class="{ 'pc': isWeChatPCBrowser() || isPC(), 'print': isPrint }">
			<div class="top">{{ navigatorTitle }}</div>
			<div class="container">
				<div id="zoomBox">
					<div class="summary_title">
						<div class="name" v-if="departInfo">{{ departInfo.departName }}
							<template v-if="detailInfo.orderType == 1">（预算报价单）</template>
							<template v-if="detailInfo.orderType == 2">（订单报价单）</template>
						</div>
						<div class="date" v-if="detailInfo">
							<template v-if="detailInfo.orderType == 1">
								日期：{{ detailInfo.createTime }}
							</template>
							<template v-if="detailInfo.orderType == 2">
								<span class="lf" style="margin-right: 0px">
									日期：{{ detailInfo.offerTime || '-' }}
								</span>
								<!-- <span>报价单号：
									<span>{{ detailInfo.offerNo ? detailInfo.offerNo : "-" }}</span>
								</span> -->
							</template>
						</div>
					</div>
					<div class="userinfo">
						<div class="title">客户信息</div>
						<div class="userinfo_cont" v-if="customerDetail">
							<div>
								公司名称：{{ customerDetail.departName || '-' }}<br />
								联系地址：{{ customerDetail.address }}
							</div>
							<div class="rt">
								联系人：{{ customerDetail.customerName }}<br />
								联系电话：{{ customerDetail.phone }}
							</div>
						</div>
					</div>
					<div class="userinfo" style="border-bottom: 0;">
						<!-- <div class="title">项目信息</div> -->
						<div class="userinfo_cont" v-if="projectInfo">
							<div>
								项目名称：{{ projectInfo.projectName }}<br />
								送货地址：{{ projectInfo.provinceName }}{{ projectInfo.cityName }}{{ projectInfo.districtName }}{{
									projectInfo.address }}
							</div>
							<div class="rt">
								配送运费：<template v-if="projectInfo.distributionType == 1">运费到付</template>
								<template v-if="projectInfo.distributionType == 2">运费寄付</template><br />
								收货人：{{ projectInfo.uaRealName }}<br />
								联系电话：{{ projectInfo.uaMobile }}
							</div>
						</div>
					</div>

					<div class="table-wrapper" :class="{ 'print': isPrint }">
						<table border="0" cellpadding="0" cellspacing="0" class="mytable">
							<tr>
								<th>序号</th>
								<th v-for="(item, idx) in tableTitle" :key="idx" :class="{ 'p-n': item.key == 'productName' }">{{
									item.label
								}}</th>
							</tr>
							<tbody>
								<tr v-for="(item, index) in productList" :key="index">
									<td>{{ index + 1 }}</td>
									<td v-if="printFields.indexOf('productName') >= 0" class="p-n">{{ item.productName }}</td>
									<template v-if="(item.proType == 1 || item.proType == 3) && printFields.indexOf('standardsName') >= 0">
										<!-- 成品件 自定义商品 -->
										<td>{{ item.standardsName }}</td>
									</template>
									<template v-if="(item.proType == 2 || item.proType == 4) && printFields.indexOf('standardsName') >= 0">
										<!-- 加工件 来料加工-->
										<td>{{ handerNodeValueList(item.nodeValueList) }}</td>
									</template>
									<td v-if="printFields.indexOf('unitName') >= 0">{{ item.unitName }}</td>
									<td v-if="printFields.indexOf('orderNum') >= 0">{{ item.orderNum }}</td>
									<!-- 参数 -->
									<td v-if="printFields.indexOf('ps') >= 0">{{ item.ps }}</td>
									<!-- 面积 -->
									<td v-if="printFields.indexOf('areaNumContract') >= 0">{{ item.areaNumContract }}</td>
									<!-- 合计面积 -->
									<td v-if="printFields.indexOf('totalAreaNumContract') >= 0">{{ (item.areaNumContract *
										item.orderNum).toFixed(2) }}</td>
									<!-- 平方单价￥ -->
									<td v-if="printFields.indexOf('areaUnitPrice') >= 0">{{ item.outFactoryBasePrice }}</td>
									<!-- 单件价￥ -->
									<td class="td_bg" v-if="printFields.indexOf('outFactoryBasePrice') >= 0">
										{{ item.areaUnitPrice }}
									</td>
									<!-- 小计￥ -->
									<td v-if="printFields.indexOf('totalAmountContract') >= 0">{{ item.totalAmountContract }}</td>
								</tr>
							</tbody>
							<tfoot v-if="isShowOrderNum || isShowOutFactoryPrice || isShowUnitPrice || isShowTotalAmount">
								<tr class="total">
									<td>合计</td>
									<td v-for="(item, index) in tableTitle" :key="index">
										<span v-if="item.key == 'orderNum'">{{ totalCount }}</span>
										<span v-if="item.key == 'outFactoryPrice'"></span>
										<span v-if="item.key == 'outFactoryBasePrice'"></span>
										<span v-if="item.key == 'totalAmountContract'">{{ totalPrice.toFixed(2) }}</span>
									</td>
								</tr>
								<tr class="total">
									<td :colspan="tableTitle.length + 1" style="text-align: right;">
										<span v-if="taxFlag == '0'">不含税价格：{{ totalPrice.toFixed(2) }}</span>
										<span v-if="taxFlag == '1'">含税价格：{{ (totalPrice / 0.9).toFixed(2) }}</span>
									</td>
								</tr>
							</tfoot>
						</table>
					</div>
					<div class="summary_f">
						<div class="lf" v-if="departInfo">
							<span class="name">{{ departInfo.departName }}</span>
							<div class="contact">
								联系人：{{ departInfo.realname }}，地址：{{ departInfo.address }}<br />
								电话：{{ departInfo.phone }} 传真：{{ departInfo.fax || "" }}
							</div>
							<div class="contact">
								经营范围：<br />
								<div v-if="departInfo.memo">
									{{ departInfo.memo }}
								</div>
							</div>
						</div>
						<div class="rt">
							<!-- <img class="qr" src="../assets/qr.jpg" /> -->
						</div>
					</div>

					<!-- 备注 -->
					<div class="beizhu" v-if="type == 2">
						<span class="lf" style="margin-right: 10px;">备注</span>
						<div class="cot">{{ forwardDesc }}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="sign_box" v-if="type == 2">
			<div class="sign_item">
				<div class="bt">卖方签字</div>
				<div class="sign_content">
					<img :src="sysQuotationSheet.saleSignImg" class="img"
						v-if="sysQuotationSheet && sysQuotationSheet.saleSignImg" />
				</div>
				<div class="sign_tip" v-if="sysQuotationSheet && !sysQuotationSheet.saleSignImg">待签字</div>
				<div class="signed" v-if="sysQuotationSheet && sysQuotationSheet.saleSignImg">
					{{ sysQuotationSheet.saleSignTimeStr }}
					签署
				</div>
				<template v-if="sysQuotationSheet && sysQuotationSheet.departSignImg">
					<img :src="sysQuotationSheet.departSignImg" class="zhang" />
				</template>
			</div>
			<div class="sign_item" @click="sign()">
				<div class="bt">买方签字</div>
				<div class="sign_content">
					<img :src="sysQuotationSheet.buySignImg" class="img" v-if="sysQuotationSheet && sysQuotationSheet.buySignImg" />
				</div>
				<div class="sign_tip" v-if="sysQuotationSheet && !sysQuotationSheet.buySignImg">待签字</div>
				<div class="signed" v-if="sysQuotationSheet && sysQuotationSheet.buySignImg">
					{{ sysQuotationSheet.buySignTimeStr }}
					签署
				</div>
				<template v-if="sysQuotationSheet && sysQuotationSheet.buyDepartSignImg">
					<img :src="sysQuotationSheet.buyDepartSignImg" class="zhang" />
				</template>
			</div>
		</div>
		<PriceOrderAutograph @signAutoGraph="signAutoGraph" ref="autoGraph" :hasPass="false" :hasTips="true">
		</PriceOrderAutograph>
	</div>
</template>

<script>
import axios from "axios"
import $http from "@/common/api/request.js"
import PriceOrderAutograph from '@/components/PriceOrderAutograph.vue'
import { EasyScroller } from 'easyscroller'
import {
	getQueryString,
	timeStampToYMD,
	base64toFile,
	isInWechatMiniProgram
} from "@/common/comm.js"
export default {
	name: "offer",
	data() {
		return {
			navigatorTitle: "",
			ordId: "",
			userId: null,
			salt: "",
			type: null,
			taxFlag: '0',
			printFields: [],
			tableTitle: [],
			isInit: false,
			dialogTxt: "修改的数据未保存<br />确定退出吗？",
			okText: "继续修改",
			cancelText: "不保存退出",
			resetText: "还原",
			isReset: false,
			userInfo: null,
			departInfo: null,
			projectInfo: null,
			customerDetail: null,
			detailInfo: null,
			productList: [],
			totalCount: 0,
			totalPrice: 0,
			totalUnitPrice: 0,
			pricePercentage: 0,
			scroller: null,
			buyDepartSignImg: '',
			buySignImg: '',
			forwardDesc: '',
			sysQuotationSheet: null,
			isShowOrderNum: true,
			isShowOutFactoryPrice: true,
			isShowUnitPrice: true,
			isShowTotalAmount: true,
			isPrint: false
		}
	},
	components: {
		PriceOrderAutograph
	},
	mounted() {
		let request = getQueryString()
		this.ordId = request["id"]
		this.salt = request["salt"]
		this.type = request["type"]
		this.userId = request['userId']
		this.taxFlag = request['taxFlag']
		this.isShowOrderNum = request['isShowOrderNum'] || false
		this.isShowOutFactoryPrice = request['isShowOutFactoryPrice'] || false
		this.isShowUnitPrice = request['isShowUnitPrice'] || false
		this.isShowTotalAmount = request['isShowTotalAmount'] || false
		let tempTableTitle = request["tableTitle"] ? JSON.parse(request["tableTitle"]) : []
		this.tableTitle = tempTableTitle.map(key => {
			let title = ''
			if (key == 'productName') { title = '产品名称' }
			if (key == 'standardsName') { title = '规格型号' }
			if (key == 'unitName') { title = '单位' }
			if (key == 'orderNum') { title = '数量' }
			if (key == 'ps') { title = '参数' }
			if (key == 'areaNumContract') { title = '面积' }
			if (key == 'totalAreaNumContract') { title = '合计面积' }
			if (key == 'areaUnitPrice') { title = '平方单价' }
			if (key == 'outFactoryPrice') { title = '出厂价￥' }
			if (key == 'outFactoryBasePrice') { title = '单件价￥' }
			if (key == 'totalAmountContract') { title = '小计' }
			return { key, label: title }
		})
		this.tableTitle = this.tableTitle.filter(item => item.key != 'outFactoryPrice')
		this.printFields = tempTableTitle
		this.getOfferDetail()
		if (!this.isWeChatPCBrowser() && !this.isPC()) {
			// this.setScroller()
		}
		// 打印前触发
		window.addEventListener('beforeprint', () => {
			// console.log('打印前事件')
			this.isPrint = true
			// summary_container.pc
		});
		window.addEventListener('afterprint', () => {
			// console.log('打印或预览已关闭')
			this.isPrint = false
		})
	},
	beforeDestroy() {
		if (this.scroller) this.scroller.destroy()
	},
	methods: {
		getOfferDetail() {
			if (this.ordId) {
				let params = {
					url: '/sys/order/preview?id=' + this.ordId + "&salt=" + this.salt + "&userId=" + this.userId,
					method: 'GET',
					header: {
						'Content-Type': 'application/json',
					}
				}
				$http.request(params).then((res) => {
					if (res.code == 200) {
						this.isInit = true
						this.detailInfo = res.result
						if (res.result.offerTime) {
							this.detailInfo = { ...this.detailInfo, createTime: timeStampToYMD(res.result.createTime), offerTime: timeStampToYMD(res.result.offerTime) }
						} else {
							this.detailInfo = { ...this.detailInfo, createTime: timeStampToYMD(res.result.createTime), offerTime: '-' }
						}

						this.customerDetail = res.result.customerInfoVO
						this.departInfo = res.result.userInfoVO
						this.projectInfo = res.result.orderAddressVO
						if (this.type == 1) {
							this.navigatorTitle = '预算单'
							if (!isInWechatMiniProgram()) {
								document.title = '预算单'
							}
							this.productList = this.handerProduct(res.result.orderProductVOList)
						}
						if (this.type == 2) {
							res.result.offerNo = res.result.offerNo ? res.result.offerNo.replace(/^#?bjd/i, 'BJD').replace(/(\d{8})\d{6}/, '$1') : '';
							this.navigatorTitle = '报价单' + (res.result.offerNo || "")
							if (!isInWechatMiniProgram()) {
								document.title = '报价单' + (res.result.offerNo || "")
							}
							if (res.result.sysQuotationSheet) {
								this.sysQuotationSheet = res.result.sysQuotationSheet
								this.forwardDesc = this.sysQuotationSheet ? this.sysQuotationSheet.forwardDesc : ''
							}
							this.productList = this.handerProduct(res.result.orderProductVOList)
						}
						this.calcCountAndPrice()
					}
				}).catch(() => { })
			}
		},
		setScroller() {
			const ele = document.querySelector('#zoomBox'); //缩放盒子
			this.scroller = new EasyScroller(ele, {
				scrollingX: true,
				scrollingY: true,
				zooming: true,
				minZoom: 1,    //最小缩放
				maxZoom: 4,    //最大缩放
				zoomLevel: 1, //初始值缩放
				bouncing: false
			});

		},
		calcCountAndPrice() {
			this.totalCount = 0
			this.totalPrice = 0
			this.productList.forEach((item) => {
				this.totalCount += item.orderNum
				if (this.type == 1) {
					this.totalPrice += Number(item.totalAmount || 0)
					this.totalUnitPrice += (item.unitPrice || 0)
				}
				if (this.type == 2) {
					this.totalPrice += Number(item.totalAmountContract || 0)
					this.totalUnitPrice += (item.outFactoryBasePrice || 0)
				}
			})
		},
		handerProduct(orderProductVOList) {
			let tempArr = []
			orderProductVOList = orderProductVOList.filter((pro) => pro.isAttachProd == 0)
			orderProductVOList.forEach((product) => {
				return product.orderItemVOList.forEach((orderItem) => {
					let ps = []
					// 处理参数A
					let alist = product.aPriceRateVOList;  //aPriceRateVOList
					if (alist?.length) {
						let obj = JSON.parse(product.aPriceRateLable);
						let tit = Object.values(obj);
						let vStr = orderItem.thicknessIdPathA;
						let vArr = vStr ? vStr.split("-") : [];
						if (vArr.length) {
							let aVal = [];
							let ii = alist.findIndex((x) => x.id == vArr[0]);
							if (ii > -1) {
								aVal.push(alist[ii].texture);
								let jj = alist[ii].thicknessVOList.findIndex(
									(x) => x.id == vArr[1]
								);
								let v =
									jj > -1 ?
										alist[ii].thicknessVOList[jj].thickness :
										"--";
								aVal.push(v);
							} else {
								aVal = ["--", "--"];
							}
							for (let n = 0; n < tit.length; n++) {
								ps.push(aVal[n]);
							}
						}
					}
					// 处理参数B
					let blist = product.bPriceRateVOList;
					if (blist?.length) {
						let obj = JSON.parse(product.bPriceRateLable);
						let tit = Object.values(obj);
						let vStr = orderItem.thicknessIdPathB;
						let vArr = vStr ? vStr.split("-") : [];
						if (vArr.length) {
							let aVal = [];
							let ii = blist.findIndex((x) => x.id == vArr[0]);
							if (ii > -1) {
								aVal.push(blist[ii].texture);
								let jj = blist[ii].thicknessVOList.findIndex(
									(x) => x.id == vArr[1]
								);
								let v =
									jj > -1 ?
										blist[ii].thicknessVOList[jj].thickness :
										"--";
								aVal.push(v);
							} else {
								aVal = ["--", "--"];
							}
							for (let n = 0; n < tit.length; n++) {
								ps.push(aVal[n]);
							}
						}
					}
					// 处理参数M
					let clist = product.materialVOList;
					if (clist?.length) {
						let obj = JSON.parse(product.materialLable);
						let tit = Object.values(obj);
						let vStr = orderItem.materialLastId;
						if (vStr) {
							let aVal = [];
							let ii = clist.findIndex((x) => x.id == vStr);
							if (ii > -1) {
								aVal.push(clist[ii].name);
							} else {
								aVal = ["--"];
							}
							for (let n = 0; n < tit.length; n++) {
								ps.push(aVal[n]);
							}
						}
					}
					if (product.proType == 3) {
						// 自定义商品
						ps = orderItem.isPower ? [orderItem.isPower] : []
					}
					tempArr.push({
						...orderItem,

						unitName: product.unitName,
						productName: product.productName,
						proType: product.proType,
						ps: ps.join('|')
					})
				})
			})
			return tempArr
		},
		handerNodeValueList(nodeValueList) {
			let nodeStr = ""
			nodeValueList.forEach((item, index) => {
				if (index == nodeValueList.length - 1) {
					nodeStr += item.nodeValue
				} else {
					nodeStr += item.nodeValue + '*'
				}
			})
			return nodeStr
		},
		setPerNumber(flag) {
			if (flag == 'decrease') {
				this.pricePercentage = (Number(this.pricePercentage) - 10).toFixed(2)
				if (this.pricePercentage < 0) {
					this.pricePercentage = 0
				}
			}
			if (flag == 'plus') {
				this.pricePercentage = (Number(this.pricePercentage) + 10).toFixed(2)
			}
		},
		sign() {
			if (this.sysQuotationSheet && this.sysQuotationSheet.buySignImg) {
				return
			}
			this.$refs.autoGraph.show()
		},
		async signAutoGraph({ signPath, departName }) {
			let sealData = null;
			if (departName != '') {
				sealData = await this.getDepartSeal(departName)
			}
			const signData = await this.uploadSignImg(signPath)
			if (sealData) {
				Promise.all([sealData, signData]).then(results => {
					this.buyDepartSignImg = results[0] // 买方公司印章图片
					this.buySignImg = results[1] // 买方签名图片
					this.updateSignInfo()
				})
			} else {
				Promise.all([signData]).then(results => {
					this.buySignImg = results[0]
					this.updateSignInfo()
				})
			}
		},
		getDepartSeal(departName) {
			return new Promise((resolve, reject) => {
				let params = {
					url: '/sys/user/departSeal?departName=' + departName,
					header: {
						'Content-Type': 'application/json',
						'X-Access-Token': this.token
					},
				}
				$http.request(params).then((res) => {
					if (res.code == 200) {
						resolve(res.result)
					} else {
						reject('error')
					}
				}).catch((error) => {
					console.log(error)
				})
			})
		},
		uploadSignImg(signPath) {
			return new Promise((resolve, reject) => {
				let file = base64toFile(signPath, new Date().getTime() + Math.random() + ".jpg")
				const formData = new FormData();
				formData.append("file", file)
				axios({
					method: "post",
					headers: {
						"Content-Type": "multipart/form-data",
					},
					url: "https://fengyisuan.com/app/sys/common/upload",
					data: formData,
				})
					.then(function (res) {
						if (res.data.code == 200) {
							resolve(res.data.result)
						} else {
							reject('error')
						}
					})
					.catch(function (error) {
						console.log(error)
					});
			})
		},
		// 更新签名信息
		updateSignInfo() {
			let params = {
				url: '/sys/order/updateSignInfo',
				method: 'POST',
				header: {
					'Content-Type': 'application/json'
				},
				data: {
					orderId: this.sysQuotationSheet.orderId,
					buyDepartSignImg: this.buyDepartSignImg, // 买方公司印章图
					buySignImg: this.buySignImg // 买方签名图片
				}
			}
			$http.request(params).then((res) => {
				if (res.code == 200) {
					this.getOfferDetail()
				}
			}).catch((err) => {
				console.log(err)
			})
		},
		isWeChatPCBrowser() {
			var userAgent = navigator.userAgent.toLowerCase();
			return /micro messenger/.test(userAgent) && /windowswechat/.test(userAgent);
		},
		isPC() {
			var userAgentInfo = navigator.userAgent;
			console.log("userAgentInfo:", userAgentInfo)
			var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
			var flag = true;
			for (var v = 0; v < Agents.length; v++) {
				if (userAgentInfo.indexOf(Agents[v]) > 0) {
					flag = false;
					break;
				}
			}
			return flag;
		}
	}
}
</script>
<style scoped>
@media print {

	.userinfo_cont,
	.mytable td,
	.summary_f {
		font-size: 9pt !important;
	}

	.userinfo .title {
		font-size: 10pt !important;
	}

	.beizhu {
		border-top: 0 !important;
	}

	.sign_box {
		margin-top: 0 !important;
		border-top: 0 !important;
	}

	.sign_content {
		border: 1px solid #000 !important;
	}

	.summary_container {
		/* border: 1px solid #000 !important; */
	}
	.summary_f {
		border-bottom: 1px solid #000 !important;
	}
	.beizhu {
		padding: 10px !important;
	}
	tfoot {
    display: table-row-group;
    /* 或者 display: block; */
  }
	.mytable {
		border-top: 1px solid #000!important;
		/* border-left: 1px solid #000!important;
		border-right: 1px solid #000!important; */
		box-sizing: border-box;
	}
  .summary_title .name {
    font-size: 12pt !important;
  }
	/* 强制签名区域不被分页打断 */
	.sign,
	.sign-item,
	.sign_box,
	.sign-item .write,
	.sign-item .zhang {
		page-break-inside: avoid !important;
		break-inside: avoid !important;
		/* 新版 CSS 属性，兼容性更好 */
	}
}

.top {
	/* position: fixed;
	left: 0;
	right: 0;
	top: 0;
	z-index: 10; */
	background-color: #fff;
	width: 100%;
	height: 44px;
	text-align: center;
	font-size: 18px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.summary_container.pc,.signbox {
	max-width: 980px;
}

.summary_container.print {
	width: 100% !important;
	max-width: 100% !important;
}

.summary_container.pc .summary_title .name {
	font-size: 14px;
}

.summary_container.pc .summary_title .date {
	font-size: 12px;
}

.summary_container.pc .userinfo .title {
	font-size: 14px;
}

.summary_container.pc .userinfo_cont {
	font-size: 12px;
}

.summary_container.pc .summary_f .name {
	font-size: 14px;
}

.summary_container.pc .summary_f .contact {
	font-size: 12px;
}

.summary_container {
	margin: 0 auto 0 auto;
	padding-top: 0;
}

.summary_container.pc .mytable th {
	font-size: 12px;
	white-space: nowrap;
}

.summary_container.pc .mytable td {
	font-size: 12px;
	white-space: nowrap;
}

.container {
	/* height: calc(100vh - 44px);
	overflow: hidden; */
}

.tips {
	text-align: center;
	font-size: 10px;
	padding-bottom: 15px;
}

.summary_title {
	padding: 8px 10px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-top: 1px solid #000;
	border-bottom: 1px solid #000;
	background-color: #fff;
}

.summary_title .name {
	font-size: 12px;
	font-weight: bold;
	flex: 1;
	white-space: nowrap;
}

.summary_title .date {
	flex: 1;
	font-size: 12px;
	text-align: right;
	display: flex;
	align-items: center;
	justify-content: flex-end;
}

.summary_title .date .lf {
	margin-right: 30rpx;
}

.userinfo {
	display: flex;
	flex-direction: column;
	padding: 8px 10px;
	border-bottom: 1px solid #000;
	background-color: #fff;
}

.userinfo .title {
	font-weight: bold;
	font-size: 12px;
	padding-bottom: 8px;
}

.userinfo_cont {
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	font-size: 12px;
}

.userinfo_cont .rt {
	text-align: left;
}

.table-wrapper {
	width: 100%;
	overflow-x: auto;
	/* 推荐用 auto，只在需要时显示滚动条 */
	-webkit-overflow-scrolling: touch;
	/* 移动端流畅滚动（可选） */
	/* border: 1px solid red; */
}

.table-wrapper.print {
	overflow: visible !important;
}

.mytable {
	width: 100%;
	background-color: #fff;
}

.mytable th {
	font-size: 12px;
	color: #000;
	font-weight: normal;
	text-align: center;
	padding: 7px;
	background-color: #F6F6F6;
	border-bottom: 1px solid #000;
	white-space: nowrap;
}

.mytable td {
	font-size: 12px;
	color: #000;
	font-weight: normal;
	text-align: center;
	padding: 7px;
	border-bottom: 1px solid #000;
	white-space: nowrap;
}

.table_foot td {
	background-color: #F6F6F6;
	padding: 10px 10px;
}

.table_foot .txt {
	font-weight: bolder;
}

.summary_f {
	display: flex;
	justify-content: space-between;
	font-size: 12px;
	padding: 10px 10px 24px 10px;
	border-bottom: 1px solid #9F9F9F;
	background-color: #fff;
}

.summary_f .lf {
	padding-right: 15px;
}

.summary_f .name {
	font-size: 12px;
	font-weight: bold;
}

.summary_f .contact {
	margin: 6px 0 10px 0;
}

.summary_f .rt {
	flex: 0 0 80px;
}

.beizhu {
	font-size: 10px;
	padding: 10px 10px 0px 10px;
	background-color: #fff;
	border-top: 10px solid #F6F6F6;
	overflow: hidden;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.beizhu .bt {}

.beizhu .cot {
	padding: 10px 0;
	flex: 1;
}

.qr {
	width: 80px;
	height: 80px;
}

.sign_box {
	max-width: 980px;
	margin: 10px auto;
	background-color: #fff;
	padding: 20px 10px 20px 10px;
	display: flex;
	justify-content: space-between;
	border-top: 10px solid #F6F6F6;
}

.sign_item {
	width: 172px;
	font-size: 10px;
	display: flex;
	flex-direction: column;
	position: relative;
}

.sign_item .zhang {
	width: 109px;
	height: 109px;
	position: absolute;
	right: 10px;
	bottom: 0;
}

.sign_item .bt {
	text-align: center;
	margin-bottom: 12px;
}

.sign_item .sign_tip {
	text-align: center;
	color: #FF0000;
	margin-top: 14px;
}

.sign_item .signed {
	text-align: center;
	color: #000;
	margin-top: 14px;
}

.sign_content {
	width: 172px;
	height: 110px;
	background: #F5F5F5;
	border: 1px solid #A3A3A3;
	display: flex;
	align-items: center;
	justify-content: center;
}

.sign_content .img {
	width: 88px;
	height: 67px;
}

.fbtn {
	width: 100%;
	height: 49px;
	position: fixed;
	left: 0;
	bottom: 0;
	color: #333;
	background-color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;
}

.fbtn .lf {
	flex: 1;
	display: flex;
}

.fbtn .f_u {
	flex: 1;
	height: 49px;
	text-align: center;
	line-height: 49px;
	border-right: 1px solid #C3C3C3;
}

.fbtn .f_u:last-child {
	border-right: 0;
}

.fbtn .contract {
	width: 88px;
	height: 49px;
	background-color: #0072DC;
	color: #fff;
	text-align: center;
	line-height: 49px;
}

.fbtn .order {
	width: 88px;
	height: 49px;
	background-color: #F83144;
	color: #fff;
	text-align: center;
	line-height: 49px;
}

.transfer_box {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.transfer_box .cancel {
	text-align: right;
	font-size: 14px;
	padding: 20px;
	width: 100%;
	box-sizing: border-box;
}

.transfer_box .icon {
	width: 50px;
	height: 50px;
	margin-bottom: 10px;
}

.transfer_main {
	display: flex;
	flex-direction: column;
	align-items: center;
	font-size: 14px;
}

.p-n {
	text-align: left !important;
}

.mask {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background: rgba(0, 0, 0, .5);
	z-index: 21;
}
</style>